import { mailConstants } from '../constants/mail.constants';
import mailService from '../services/mail.service';
import { alertActions } from './alert.actions';
import { history } from '../helpers';

export const mailActions = {
  create,
  update,
  remove,  
  fetch,  
  test,
  get  
};

function create (obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const mailTransport = await mailService.create(obj);
      dispatch(success(mailTransport));
      dispatch(alertActions.success("Servidor criado"));
      history.push('/mail');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: mailConstants.CREATE_REQUEST } }
  function success(mailTransport) { return { type: mailConstants.CREATE_SUCCESS, mailTransport } }
  function failure(error) { return { type: mailConstants.CREATE_FAILURE, error } }
}

function update (id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const mailTransport = await mailService.update(id, obj);
      dispatch(success(mailTransport));
      dispatch(alertActions.success("Servidor alterado"));
      history.push('/mail');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: mailConstants.UPDATE_REQUEST } }
  function success(mailTransport) { return { type: mailConstants.UPDATE_SUCCESS, mailTransport } }
  function failure(error) { return { type: mailConstants.UPDATE_FAILURE, error } }
}

function test (id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const testResult = await mailService.test(id, obj);
      dispatch(success({ error: false, message: "E-mail enviado" }));      
    } catch(error) {
      dispatch(failure({ error: true, message: error }));              
    }
  };

  function request() { return { type: mailConstants.TEST_REQUEST } }
  function success(testResult) { return { type: mailConstants.TEST_SUCCESS, testResult } }
  function failure(testResult) { return { type: mailConstants.TEST_FAILURE, testResult } }
}

function remove(id) {
  return async dispatch => {
    dispatch(request());
    try {
      await mailService.remove(id);
      dispatch(success(true));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: mailConstants.REMOVE_REQUEST } }
  function success(mailTransport) { return { type: mailConstants.REMOVE_SUCCESS, mailTransport } }
  function failure(error) { return { type: mailConstants.REMOVE_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const mailTransports = await mailService.fetch(params);

      dispatch(success(mailTransports));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: mailConstants.FETCH_REQUEST } }
  function success(mailTransports) { return { type: mailConstants.FETCH_SUCCESS, mailTransports } }
  function failure(error) { return { type: mailConstants.FETCH_FAILURE, error } }
}

function get(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const mailTransport = await mailService.get(id);
      dispatch(success(mailTransport));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: mailConstants.GET_REQUEST } }
  function success(mailTransport) { return { type: mailConstants.GET_SUCCESS, mailTransport } }
  function failure(error) { return { type: mailConstants.GET_FAILURE, error } }
}


